export const ANALYTICS_EVENT = {
  SUBSCRIPTION_STARTED: 'begin_checkout_landing',
  SUBSCRIPTION_NEXT: 'subscription_next_clicked',
  SUBSCRIPTION_PREVIOUS: 'subscription_previous_clicked',
  SUBSCRIPTION_PAYMENT: 'subscription_payment_clicked',
  SUBSCRIPTION_ADD_PAYMENT_INFO: 'add_payment_info',
  SUBSCRIPTION_SIGN_UP: 'sign_up',
  RESUBSCRIPTION: 'resubscription',
};
